import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

export default [
  {
    path: "/settings",
    name: "Setting Details",
    meta: { title: "Nastavitve" },
    component: () => import(/* webpackChunkName: "Setting Details" */ "@/Modules/Setting/Views/Details/Details"),
    beforeEnter: ifAuthenticated
  },
  {
    path: "/user-info",
    meta: { title: "Nastavitve" },
    component: () => import(/* webpackChunkName: "Setting Details" */ "@/Modules/Setting/Views/UserInfo/Details"),
    beforeEnter: ifAuthenticated
  }
]
